import { ref as g, computed as M, onMounted as Y, openBlock as j, createElementBlock as q, normalizeStyle as R, unref as O, renderSlot as T, pushScopeId as V, popScopeId as D, createElementVNode as F } from "vue";
const G = (o, n) => {
  const w = o.__vccOpts || o;
  for (const [i, u] of n)
    w[i] = u;
  return w;
}, J = (o) => (V("data-v-b381b449"), o = o(), D(), o), K = /* @__PURE__ */ J(() => /* @__PURE__ */ F("div", { class: "canvasBox" }, [
  /* @__PURE__ */ F("canvas", { id: "canvas" })
], -1)), Q = {
  name: "vue-damp-fireworks"
}, U = /* @__PURE__ */ Object.assign(Q, {
  props: {
    boxHeight: {
      type: Number,
      default: window.innerHeight - 104
    },
    boxWidth: {
      type: Number,
      default: window.innerWidth
    },
    duration: {
      type: Number,
      default: 0
    }
  },
  setup(o) {
    const n = o, w = g(0), i = g([]), u = g([]), k = g(!0), p = g(n.boxHeight), r = g(n.boxWidth), x = M(() => document.getElementById("canvas")), a = M(() => x.value !== void 0 ? x.value.getContext("2d") : null), A = M(() => {
      if (p.value)
        return typeof p.value == "number" || typeof p.value == "string" ? `${p.value}px` : "";
    }), z = M(() => {
      if (r.value)
        return typeof r.value == "number" || typeof r.value == "string" ? `${r.value}px` : "";
    }), L = () => {
      x.value.width = r.value, x.value.height = p.value;
    }, P = () => {
      if (a.value !== void 0) {
        W(), a.value.globalCompositeOperation = "lighter";
        for (let e = 0; e < i.value.length; e += 1)
          i.value[e].dead ? i.value.splice(e, 1) : (i.value[e].move(), i.value[e].draw());
        for (let e = 0; e < u.value.length; e += 1)
          u.value[e].dead ? u.value.splice(e, 1) : (u.value[e].move(), u.value[e].draw());
        if (k.value && w.value % 40 === 0) {
          const e = C(
            c(20, r.value - 20),
            p.value - 20,
            c(175, 185),
            [c(0, 359), "100%", "50%"]
          );
          i.value.push(e);
        }
        a.value.globalCompositeOperation = "destination-out", requestAnimationFrame(P), w.value += 1;
      }
    }, W = () => {
      a.value !== void 0 && (a.value.fillStyle = "rgba(0, 0, 0, 0.1)", a.value.fillRect(0, 0, n.boxWidth, n.boxHeight));
    }, B = (e, l, h) => {
      a.value !== void 0 && (a.value.beginPath(), a.value.arc(e, l, h, 0, 2 * Math.PI), a.value.closePath());
    }, C = (e, l, h, s) => {
      const _ = s[0], b = s[1], y = s[2], m = `hsla(${_}, ${b}, ${y}, 1)`, $ = !1, t = {};
      let d = 2;
      return t.x = e, t.y = l, t.move = () => {
        t.y > c(100, 200) ? (d += 0.05, t.x += d * Math.sin(Math.PI / 180 * h), t.y += d * Math.cos(Math.PI / 180 * h)) : (t.explode(), t.dead = !0);
      }, t.draw = () => {
        a.value.fillStyle = m, B(t.x, t.y, 3), a.value.fill();
      }, t.explode = () => {
        for (let f = 0; f < 359; f += 4) {
          const I = X(t.x, t.y, f + c(-200, 200) / 100, [_, b, y]);
          u.value.push(I);
        }
      }, t.dead = $, t;
    }, X = (e, l, h, s) => {
      const v = {}, E = c(-20, 20) / 100, _ = 1, b = -0.01, y = 0.01;
      let m = 1, $ = `hsla(${s[0]}, ${s[1]}, ${s[2]}, ${m})`, t = 0, d = c(195, 205) / 100, f = h, I = e, H = l;
      return v.dead = !1, v.move = () => {
        m > 0 ? (d > 0 && (d += b), f += E, m -= 5e-3, $ = `hsla(${s[0]}, ${s[1]}, ${s[2]}, ${m})`, t += y, I += d * Math.sin(Math.PI / 180 * f), H += d * Math.cos(Math.PI / 180 * f) + t) : v.dead || (v.dead = !0);
      }, v.draw = () => {
        a.value.fillStyle = $, B(I, H, _), a.value.fill();
      }, v;
    }, c = (e, l) => Math.floor(Math.random() * (l - e + 1) + e);
    return Y(() => {
      L(), P(), n.duration && setTimeout(() => {
        k.value = !1;
      }, n.duration), window.addEventListener("click", (e) => {
        const l = C(e.pageX, e.pageY, self.randomInt(175, 185), [self.randomInt(0, 359), "100%", "50%"]);
        i.value.push(l);
      }), window.addEventListener("resize", () => {
        r.value = window.innerWidth, x.value.width = r.value, W();
      });
    }), (e, l) => (j(), q("div", {
      class: "vue-damp-fireworks-wrap",
      style: R(`
      height: ${O(A)};
      width: ${O(z)};
    `)
    }, [
      K,
      T(e.$slots, "default", {}, void 0, !0)
    ], 4));
  }
}), N = /* @__PURE__ */ G(U, [["__scopeId", "data-v-b381b449"]]), Z = [
  {
    name: N.name || "vue-damp-fireworks",
    component: N
  }
], S = function(o) {
  S.installed || (S.installed = !0, Z.forEach((n) => {
    o.component(n.name, n.component);
  }));
}, te = {
  install: S
};
export {
  N as Fireworks,
  te as default
};
